import { Progress } from '@/components/ui/progress'
import { categoryLabel, SITE_HEALTH_CATEGORIES } from '@/lib/siteHealth'
import { CARD_CLASS, scoreTone } from './SiteHealthStyles'
import type { CategoryScoreGridProps } from './siteHealthComponents.types'

export default function CategoryScoreGrid({
  overview,
}: CategoryScoreGridProps) {
  return (
    <section className={`${CARD_CLASS} p-6`}>
      <h2 className="text-lg font-semibold">Category health</h2>

      <div className="mt-5 grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
        {SITE_HEALTH_CATEGORIES.map((category) => {
          const score = overview.categoryScores.find(
            (candidate) => candidate.category === category
          )

          return (
            <article
              key={category}
              className="rounded-xl border border-border/70 bg-background p-4"
            >
              <p className="text-sm font-medium">{categoryLabel(category)}</p>
              {score &&
              score.evaluationState !== 'not_evaluated' &&
              score.evaluatedRules !== 0 ? (
                <>
                  <p
                    className={`mt-3 text-2xl font-semibold tabular-nums ${scoreTone(score.score)}`}
                  >
                    {score.score}
                    <span className="ml-1 text-sm font-normal text-muted-foreground">
                      / {score.max}
                    </span>
                  </p>
                  <Progress
                    aria-label={`${categoryLabel(category)} score`}
                    className="mt-3 h-1.5"
                    indicatorClassName="bg-primary/80"
                    value={score.percent}
                  />
                </>
              ) : (
                <p className="mt-3 text-sm text-muted-foreground">
                  Not evaluated
                </p>
              )}
            </article>
          )
        })}
      </div>
    </section>
  )
}
